"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUsers = getUsers;

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var HUB_USERS_URI = 'users/v1/app/hub-users';

function getUsers() {
  return _apiClient.default.get(HUB_USERS_URI, {
    query: {
      scopes: true
    }
  });
}